module.exports = __webpack_public_path__ + "img/Old_Spiked_Collar.ba57d8e7.png";